import styled from 'styled-components';

export const Paragraph = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
  vertical-align: baseline;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  margin: 10px;
`;
